<template>
  <div class="absolute inset-y-0 left-0 pt-6 pl-3">
    <div
      data-v-step="newRegister"
      class="group flex items-center cursor-pointer"
      @click="showSelectPoint"
    >
      <div
        v-bind:class="
          showSelectHelper
            ? 'bg-red-500 group-hover:bg-danger-color'
            : 'bg-primary-color group-hover:bg-primary-color-dark'
        "
        class="px-3 py-3 rounded-full shadow-lg text-gray-100 flex items-center z-10"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          enable-background="new 0 0 24 24"
          viewBox="0 0 24 24"
          class="h-6 w-6 fill-current text-gray-100"
        >
          <g><rect fill="none" height="24" width="24" /></g>
          <g>
            <g>
              <rect height="4" width="4" x="10" y="4" />
              <rect height="4" width="4" x="4" y="16" />
              <rect height="4" width="4" x="4" y="10" />
              <rect height="4" width="4" x="4" y="4" />
              <rect height="4" width="4" x="16" y="4" />
              <polygon
                points="11,17.86 11,20 13.1,20 19.08,14.03 16.96,11.91"
              />
              <polygon points="14,12.03 14,10 10,10 10,14 12.03,14" />
              <path
                d="M20.85,11.56l-1.41-1.41c-0.2-0.2-0.51-0.2-0.71,0l-1.06,1.06l2.12,2.12l1.06-1.06C21.05,12.07,21.05,11.76,20.85,11.56z"
              />
            </g>
          </g>
        </svg>
      </div>
      <div
        v-bind:class="
          showSelectHelper ? 'bg-danger-color' : 'bg-primary-color-dark'
        "
        class="pl-4 pr-3 py-2 -ml-3 rounded-r-full shadow-lg hidden group-hover:block text-gray-100 font-bold z-0"
      >
        Nuevo registro
      </div>
    </div>
    <div
      class="group flex items-center cursor-pointer mt-2"
      @click="showControlMap = !showControlMap"
    >
      <div
        v-bind:class="
          showControlMap
            ? 'bg-red-500 group-hover:bg-danger-color'
            : 'bg-primary-color group-hover:bg-primary-color-dark'
        "
        class="px-3 py-3 rounded-full shadow-lg text-gray-100 flex items-center z-10"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 fill-current text-gray-100"
          viewBox="0 0 24 24"
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path
            d="M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z"
          />
        </svg>
      </div>
      <div
        v-bind:class="
          showControlMap ? 'bg-danger-color' : 'bg-primary-color-dark'
        "
        class="pl-4 pr-3 py-2 -ml-3 rounded-r-full shadow-lg hidden group-hover:block text-gray-100 font-bold z-0"
      >
        Tipo de mapa
      </div>
    </div>
    <control-map
      :showing="showControlMap"
      @click="changeMapLayer"
    ></control-map>
  </div>
</template>
<script>
import controlMap from "./ControlMap";

export default {
  name: "Button",
  data() {
    return {
      showSelectHelper: false,
      showControlMap: false
    };
  },
  mounted() {},
  components: {
    controlMap
  },
  methods: {
    changeMapLayer(map) {
      this.$emit("click", map);
    },
    showSelectPoint() {
      this.$emit("showPointSelector");
    }
  },
  props: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
